import { render, staticRenderFns } from "./CopyRehearsalComponent.vue?vue&type=template&id=646e486c&"
import script from "./CopyRehearsalComponent.vue?vue&type=script&lang=js&"
export * from "./CopyRehearsalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports